import { Injectable } from '@angular/core';
import {
  DownloadAvailableAction,
  UpdateOrderProgressSuccessAction,
} from '@features/orders/actions';
import { OrderStatus } from '@imcc/transport';
import { NotificationService } from '../notification/notification.service';
import { StateService } from '../state/state.service';
import { OrdersService } from './order.service';
import { PersistedOrder } from './persisted-order';

@Injectable()
export class OrderProgressService {
  constructor(
    private ordersService: OrdersService,
    private stateService: StateService,
    private notificationService: NotificationService,
  ) { }

  refresh({ orderId }: PersistedOrder): void {
    this.ordersService
      .updateOrder(orderId)
      // eslint-disable-next-line max-len
      .subscribe((order) => this.stateService.dispatch(new UpdateOrderProgressSuccessAction(order)));
  }

  finalize(order: PersistedOrder) {
    if (order.isCompleted) {
      this.displayCompletedToast(order);

      return this.stateService.dispatch(new DownloadAvailableAction(order));
    }

    if (order.status === OrderStatus.failed) {
      this.displayFailedToast(order);
    }

    return undefined;
  }

  private displayCompletedToast(order: PersistedOrder) {
    this.notificationService.addNotification({
      type: 'success',
      title: 'Order ready',
      message:
        `${order.name || 'Order'} (${order.orderId}) is ready. `
        + `<a href="${order.downloadUrl}>Download</a>`,
      timeOut: 3000,
    });
  }

  private displayFailedToast(order: PersistedOrder) {
    return this.notificationService.addNotification({
      type: 'warning',
      title: 'Order failed',
      message:
        `Your order ${order.orderId}  failed to complete. `
        + 'Please contact support.',
      timeOut: 10000,
    });
  }
}
